import React, { Component } from 'react';
import FileUpload from '../../components/FileUpload';
import styles from './AssetUpload.module.css';
import Divider from '../../components/Divider';
import { connect } from 'react-redux';
import { createAsset } from '../../modules/assets';
import { initSpotPoint, importFile } from '../../modules/player';
import { setView } from '../../modules/explorer';
import PropTypes from 'prop-types';
import ReactSelect from 'react-select';
import Spotpoint from '../../components/Spotpoint';
import { getMaterial, saveMaterial } from '../../modules/materials';

class AssetUpload extends Component {
  state = {
    item: null,
    statusMsg: null,
    loading: false,
    assetType: null,
    format: 'fbx',
    files: null,
    msg: null,
  };

  static contextTypes = {
    router: PropTypes.object,
  };

  uploadModelAsset = async (type, file, { renderPreview }) => {
    const { router } = this.context;
    const { id } = router.route.match.params;
    const { createAsset } = this.props;
    const { format } = this.state;
    this.setState({ loading: true });
    const assetType = format === 'gltf' ? 'low' : 'high';
    const result = await createAsset(
      { type, name: file.name, assetType, format, parentId: id, renderPreview },
      file
    );
    this.setState({ loading: false });
    if (result) {
      this.setState({
        statusMsg: result.message,
      });
    }
  };

  uploadMaterial = async (type, file) => {
    const { assetType } = this.state;
    const { router } = this.context;
    const { id } = router.route.match.params;
    const { createAsset } = this.props;
    if (!file || !assetType) {
      this.setState({
        statusMsg: 'please upload files and set the asset type ',
      });
      return;
    }
    this.setState({ loading: true });
    const result = await createAsset({ type, assetType, parentId: id }, file);
    if (result) {
      this.setState({ statusMsg: result.message, loading: false });
    }
  };

  async componentDidMount() {
    const { catogary, setView, getMaterial } = this.props;
    setView({ page: 'viewpage', catogary, activeLabel: 'upload' });
  }

  componentWillUnmount() {
    const { setView } = this.props;
    setView(null);
  }

  setAssetType = (data) => {
    this.setState({ assetType: data && data.value });
  };

  addMaterialTexture = (file, type) => {
    const { files } = this.state;
    files[type] = file;
    this.setState({ files });
  };

  updadteMaterial = async (spotX, spotY) => {
    const { router } = this.context;
    const { id } = router.route.match.params;
    const { getMaterial, saveMaterial } = this.props;
    const material = await getMaterial(id);
    if (!material) {
      console.log('No material with ');
      return;
    }
    const metadata = material.metadata;
    metadata['Spot Point'] = `(${spotX}, ${spotY})`;
    const result = await saveMaterial(id, { metadata });
    this.setState({ msg: 'Spot Point updated ' });
  };

  renderMaterialUpload() {
    const { assetType, files, msg } = this.state;
    const { catogary, initSpotPoint, importFile } = this.props;
    return (
      <div>
        <Divider />
        <div className={styles.title}>Material Type</div>
        <ReactSelect
          className={styles.select}
          value={assetType}
          onChange={this.setAssetType}
          placeholder="Material Type"
          options={[
            { label: 'Fabric', value: 'Fabric' },
            { label: 'Wood', value: 'Wood/L' },
            {
              label: 'S21 Updated Mura General Fabrics',
              value: 'Mura/s21_general',
            },
            {
              label: 'S21 Updated Mura Velvet Fabrics',
              value: 'Mura/s21_velvvet',
            },
            { label: 'Mura General Fabrics', value: 'Mura/general_new' },
            { label: 'Mura General Hard Materials', value: 'Mura/general' },
            {
              label: 'Mura General Hard Materials Light',
              value: 'Mura/general_light',
            },
            { label: 'Mura Velvet', value: 'Mura/velvet' },
            { label: 'Mura Velvet Light', value: 'Mura/velvet_light' },
            { label: 'Mura Enhanced Velvet', value: 'Mura/velvet_enhance' },
            { label: 'Mura Metallic', value: 'Mura/metallic' },
            { label: 'Mura Leather', value: 'Mura/leather' },
            { label: 'Vrscene Zip', value: 'vrscene' },
            {
              label: 'Displacement Template',
              value: 'Mura/general_displacement',
            },
          ]}
        />
        <Spotpoint
          initSpotPoint={initSpotPoint}
          file={files}
          message={msg}
          importFile={importFile}
          saveMaterial={this.updadteMaterial}
        />
        <FileUpload
          type={`import-${catogary}`}
          title=""
          navTo={this.navTo}
          onFileUpload={(file) => this.setState({ files: file })}
          filenote="zip format only"
          onUpload={this.uploadMaterial}
        />
      </div>
    );
  }

  changeFormat = (data) => {
    this.setState({ format: data && data.value });
  };

  cancelUpload = () => {
    console.log('CANCEL....');
  };

  renderModelUpload() {
    const { catogary } = this.props;
    const { format } = this.state;
    return (
      <FileUpload
        type={`import-${catogary}`}
        title=""
        filenote="Select the .FBX .OBJ .VRSCENEZIP asset file on your drive to upload"
        navTo={this.navTo}
        dropZone={true}
        previewOption={true}
        onUpload={this.uploadModelAsset}
        format={format}
        changeFormat={this.changeFormat}
        onCancel={this.cancelUpload}
      />
    );
  }

  uploadSceneAsset = async (type, file) => {
    console.log('UPLOAD SCENE TO CLARA........');
    const { router } = this.context;
    const { id } = router.route.match.params;
    const { createAsset } = this.props;
    this.setState({ loading: true });
    const result = await createAsset(
      { type, name: file.name, parentId: id },
      file
    );
    this.setState({ loading: false });
    if (result) {
      this.setState({
        statusMsg: result.message,
      });
    }
  };

  renderSceneUpload() {
    const { catogary } = this.props;
    return (
      <FileUpload
        type={`import-${catogary}`}
        title=""
        filenote="Select the zip asset file on your drive to upload"
        navTo={this.navTo}
        dropZone={true}
        onFileUpload={(file) => this.setState({ files: [file] })}
        onUpload={this.uploadSceneAsset}
        onCancel={this.cancelUpload}
      />
    );
  }

  render() {
    const { catogary } = this.props;
    const { statusMsg, loading } = this.state;
    return (
      <div className={styles.content}>
        <div className={styles.header}>
          Upload {catogary === 'materials' ? 'Material' : catogary}
        </div>
        {catogary === 'materials'
          ? this.renderMaterialUpload()
          : catogary === 'scenes'
          ? this.renderSceneUpload()
          : this.renderModelUpload()}
        {loading && <img src={'/img/loading.svg'} />}
        {statusMsg && <p className={styles.errorMsg}> {statusMsg}</p>}
      </div>
    );
  }
}

const uploadAssetPage = (catogary) =>
  connect(
    (state) => ({
      catogary: catogary,
    }),
    {
      createAsset,
      setView,
      initSpotPoint,
      getMaterial,
      saveMaterial,
      importFile,
    }
  )(AssetUpload);

export default uploadAssetPage;



// WEBPACK FOOTER //
// ./src/containers/AssetUpload/index.js